module.exports = __webpack_public_path__ + "static/media/billietells.dd0daacf.jpg";